import { User } from '../admin/admin.types';
import { PaginationMeta, PaginationParams } from '../pagination/pagination.types';
import { WebhookEvent } from './webhooks.enums';

export type WebhookConfig = {
  id: number;
  name: string;
  url: string;
  eventSubscription: WebhookEventSubscription;
};
export enum WebhookConfigDeliveryKind {
  Success = 'success',
  SomeFailed = 'some_failed',
  AllFailed = 'all_failed',
}
export type WebhookConfigDelivery =
  | { kind: WebhookConfigDeliveryKind.Success }
  | { kind: WebhookConfigDeliveryKind.SomeFailed; count: number }
  | { kind: WebhookConfigDeliveryKind.AllFailed };

export type WebhookEventSubscription = Array<{ eventType: WebhookEvent; subscription: boolean }>;

export type WebhookConfigCreateParams = Pick<WebhookConfig, 'name' | 'url' | 'eventSubscription'>;
export type WebhookConfigUpdateParams = Pick<WebhookConfig, 'id'> &
  Partial<Pick<WebhookConfig, 'name' | 'eventSubscription'>>;

export interface WebhookSecret {
  id: number;
  partialValue: string;
  revealedValue?: string;
}

export interface WebhookRequest {
  id: number;
  eventType: WebhookEvent;
  requestBody: string;
  attemptCount: number;
  nextAttemptAt: string | null;
  lastAttemptAt: string | null;
  lastResponseStatus: string | null;
  lastResponseBody: string | null;
  lastResponseError: string | null;
  createdAt: string;
  config?: WebhookConfig;
}

export interface PaginatedWebhookRequests {
  meta: PaginationMeta;
  requests: WebhookRequest[];
}

export interface WebhookRequestParams extends PaginationParams {
  configId?: string | null;
}

export interface WebhookCompanyConfig {
  emailRecipients: User[];
}

export interface WebhookCompanyConfigParams {
  emailRecipientIds: number[];
}
